import { createAction, props } from '@ngrx/store';

export const ShowSurvey = createAction('[Medallia] Show Survey', props<{ payload: any }>());
export const SetInfoForSurvey = createAction('[Medallia] Set info for medallia survey');
